import React, {useEffect} from 'react';
import Loading from '../style-guide/loading/Loading';
import {authenticateAction, invalidateUserAction} from '../../store/_auth/auth.actions';
import {navigate} from '@reach/router';
import AppRouters from '../../settings/app-routers';
import {connect} from 'react-redux';
import AuthService from "../../service/auth";

const AuthRoute = ({redirectTo, ticket, actions, user, profile, reportId}) => {

  useEffect(() => {
    if(redirectTo && user) {
      navigate(redirectTo, { state: { reportId } });
      return;
    }

    if (profile && profile.userUpdated)
      navigate(AppRouters.myReports);
    else if (profile) {
      navigate(AppRouters.profile);
    }

    if (ticket && !user) {
      AuthService.persistAuthenticationToken(ticket);
      actions.authenticateAction();
    }
  }, [ticket, user, profile]);

  return <Loading/>;
};

const mapStateToProps = (state) => ({
  user: state.authReducers.user,
  profile: state.authReducers.profile,
});

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      authenticateAction: () => dispatch(authenticateAction()),
      invalidateUser: () => dispatch(invalidateUserAction()),
    },
    dispatch
  }
};

export default React.memo(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(AuthRoute)
);
